import { render, staticRenderFns } from "./LayoutGameMultiplayer.vue?vue&type=template&id=65eb8663&scoped=true&"
import script from "./LayoutGameMultiplayer.vue?vue&type=script&lang=js&"
export * from "./LayoutGameMultiplayer.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGameMultiplayer.vue?vue&type=style&index=0&id=65eb8663&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb8663",
  null
  
)

export default component.exports